import { useIsFirstCesion } from "api/Cesion.hook"
import { useDocumentoComercialPendienteFirmar } from "api/DocumentoComercial.hook"
import { useIsFirstFactura } from "api/Factura.hook"
import { useIsFirstPagare } from "api/Pagare.hook"
import {
  useUsuarioEmpresaActiva,
  useValidacionesPendientesUsuario,
} from "api/Usuario.hook"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"

export const TabValidaciones = () => {
  const { pathname } = useLocation()
  const history = useHistory()
  const { t } = useTranslation()
  const { usuarioValidacionesPendienteResponse } =
    useValidacionesPendientesUsuario()
  const {
    activeCompany: { verificada, id },
  } = useUsuarioEmpresaActiva()
  const { isFirstPagare } = useIsFirstPagare(id)
  const { isFirstFactura } = useIsFirstFactura(id)
  const { isFirstCesion } = useIsFirstCesion(id)

  const { documentoComercialData } = useDocumentoComercialPendienteFirmar()
  const isCesionesPage = pathname === ROUTES.VALIDACIONES_CESIONES
  const isFinanciacionPage = pathname === ROUTES.VALIDACIONES_FINANCIACION
  const isDocumentosPage = pathname === ROUTES.VALIDACIONES_DOCUMENTOS
  return (
    <div className='tw-h-16 tw-w-full tw-flex tw-flex-row tw-items-center'>
      <div
        className={`tw-w-fit tw-h-12 tw-px-6 ${
          isCesionesPage ? "" : "tw-cursor-pointer"
        } ${verificada && isFirstCesion ? "" : "tw-hidden"}`}
        onClick={() =>
          !isCesionesPage && history.push(ROUTES.VALIDACIONES_CESIONES)
        }
      >
        <div
          className={`tw-h-full tw-border-b-4 ${
            isCesionesPage ? "tw-border-primary" : "tw-border-transparent"
          } tw-py-3 tw-relative`}
        >
          {t("validaciones.tabNameCesiones")}
          {usuarioValidacionesPendienteResponse?.hayCesiones && (
            <span className='tw-absolute tw-top-2 tw--right-2.5 tw-flex tw-h-2 tw-w-2'>
              <span className='tw-animate-ping tw-absolute tw-inline-flex tw-h-full tw-w-full tw-rounded-full tw-bg-warning tw-opacity-75' />
              <span className='tw-relative tw-inline-flex tw-h-2 tw-w-2 tw-rounded-full tw-bg-warning' />
            </span>
          )}
        </div>
      </div>
      <div
        className={`tw-w-fit tw-h-12 tw-px-6 ${
          isFinanciacionPage ? "" : "tw-cursor-pointer"
        } ${
          verificada && (isFirstFactura || isFirstPagare) ? "" : "tw-hidden"
        }`}
        onClick={() =>
          !isFinanciacionPage && history.push(ROUTES.VALIDACIONES_FINANCIACION)
        }
      >
        <div
          className={`tw-h-full tw-border-b-4 ${
            isFinanciacionPage ? "tw-border-primary" : "tw-border-transparent"
          } tw-py-3 tw-relative`}
        >
          {t("validaciones.tabNameFinanciacion")}
          {(usuarioValidacionesPendienteResponse?.hayFacturas ||
            usuarioValidacionesPendienteResponse?.hayPagares) && (
            <span className='tw-absolute tw-top-2 tw--right-2.5 tw-flex tw-h-2 tw-w-2'>
              <span className='tw-animate-ping tw-absolute tw-inline-flex tw-h-full tw-w-full tw-rounded-full tw-bg-warning tw-opacity-75' />
              <span className='tw-relative tw-inline-flex tw-h-2 tw-w-2 tw-rounded-full tw-bg-warning' />
            </span>
          )}
        </div>
      </div>
      <div
        className={`tw-w-fit tw-h-12 tw-px-6 ${
          isDocumentosPage ? "" : "tw-cursor-pointer"
        } ${verificada ? "" : "tw-hidden"}`}
        onClick={() =>
          !isDocumentosPage && history.push(ROUTES.VALIDACIONES_DOCUMENTOS)
        }
      >
        <div
          className={`tw-h-full tw-border-b-4 ${
            isDocumentosPage ? "tw-border-primary" : "tw-border-transparent"
          } tw-py-3 tw-relative`}
        >
          {t("validaciones.tabNameDocumentos")}
          {!!documentoComercialData?.total && (
            <span className='tw-absolute tw-top-2 tw--right-2.5 tw-flex tw-h-2 tw-w-2'>
              <span className='tw-animate-ping tw-absolute tw-inline-flex tw-h-full tw-w-full tw-rounded-full tw-bg-warning tw-opacity-75' />
              <span className='tw-relative tw-inline-flex tw-h-2 tw-w-2 tw-rounded-full tw-bg-warning' />
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
